import mara from "@/data/hashrate/mara.js";
import riot from "@/data/hashrate/riot.js";
import hut8 from "@/data/hashrate/hut8.js";
import bitf from "@/data/hashrate/bitf.js";
import hive from "@/data/hashrate/hive.js";
import argo from "@/data/hashrate/argo.js";
import btbt from "@/data/hashrate/btbt.js";
import hsshf from "@/data/hashrate/hsshf.js";

export default [
  { name: "mara", stats: mara },
  { name: "riot", stats: riot },
  { name: "hut8", stats: hut8 },
  { name: "bitf", stats: bitf },
  { name: "hive", stats: hive },
  { name: "argo", stats: argo },
  { name: "btbt", stats: btbt },
  { name: "hsshf", stats: hsshf },
]
